import { render, staticRenderFns } from "./NotifikasiAdmin.vue?vue&type=template&id=552bf94a&"
import script from "./NotifikasiAdmin.vue?vue&type=script&lang=js&"
export * from "./NotifikasiAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NotifikasiAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports